/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PlatformApiResultOfLineTextReviewUpsertResultDto } from '../models/platform-api-result-of-line-text-review-upsert-result-dto';
import { PlatformApiResultOfListOfLineTextReviewDto } from '../models/platform-api-result-of-list-of-line-text-review-dto';
import { getLineTextReviews } from '../fn/line-text-review/get-line-text-reviews';
import { GetLineTextReviews$Params } from '../fn/line-text-review/get-line-text-reviews';
import { postLineTextReviewsActionUpsert } from '../fn/line-text-review/post-line-text-reviews-action-upsert';
import { PostLineTextReviewsActionUpsert$Params } from '../fn/line-text-review/post-line-text-reviews-action-upsert';


/**
 * Review van de eigen lijnteksten van de Rave I'Ching (Mechanics in Motion): per poort,
 * lijn, taal en veld goedkeuren of herschrijven. Lezen mag elke aangemelde gebruiker (een
 * herschreven tekst geldt in de app voor iedereen); schrijven vraagt de reviewfeature.
 */
@Injectable({ providedIn: 'root' })
export class PlatformLineTextReviewService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getLineTextReviews()` */
  static readonly GetLineTextReviewsPath = '/api/line-text-reviews';

  /**
   * Alle reviewrecords (hoogstens 64 x 6 x 2 x 3), gesorteerd op poort, lijn, taal en veld.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLineTextReviews()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLineTextReviews$Response(params?: GetLineTextReviews$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfListOfLineTextReviewDto>> {
    return getLineTextReviews(this.http, this.rootUrl, params, context);
  }

  /**
   * Alle reviewrecords (hoogstens 64 x 6 x 2 x 3), gesorteerd op poort, lijn, taal en veld.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLineTextReviews$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLineTextReviews(params?: GetLineTextReviews$Params, context?: HttpContext): Observable<PlatformApiResultOfListOfLineTextReviewDto> {
    return this.getLineTextReviews$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfListOfLineTextReviewDto>): PlatformApiResultOfListOfLineTextReviewDto => r.body)
    );
  }

  /** Path part for operation `postLineTextReviewsActionUpsert()` */
  static readonly PostLineTextReviewsActionUpsertPath = '/api/line-text-reviews/action/upsert';

  /**
   * Zet de reviewstatus van één lijntekst: goedkeuren, herschrijven en goedkeuren, of de
   * goedkeuring intrekken. Een lege tekst betekent "brontekst behouden". Wijkt het record
   * intussen af van ExpectedUpdatedOn, dan komt Conflict = true terug met de actuele stand
   * en is er niets opgeslagen.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postLineTextReviewsActionUpsert()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postLineTextReviewsActionUpsert$Response(params: PostLineTextReviewsActionUpsert$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfLineTextReviewUpsertResultDto>> {
    return postLineTextReviewsActionUpsert(this.http, this.rootUrl, params, context);
  }

  /**
   * Zet de reviewstatus van één lijntekst: goedkeuren, herschrijven en goedkeuren, of de
   * goedkeuring intrekken. Een lege tekst betekent "brontekst behouden". Wijkt het record
   * intussen af van ExpectedUpdatedOn, dan komt Conflict = true terug met de actuele stand
   * en is er niets opgeslagen.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postLineTextReviewsActionUpsert$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postLineTextReviewsActionUpsert(params: PostLineTextReviewsActionUpsert$Params, context?: HttpContext): Observable<PlatformApiResultOfLineTextReviewUpsertResultDto> {
    return this.postLineTextReviewsActionUpsert$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfLineTextReviewUpsertResultDto>): PlatformApiResultOfLineTextReviewUpsertResultDto => r.body)
    );
  }

}
